import { useDispatch, useSelector } from 'react-redux';

import {
    analyticsCardSelectMinimumPaymentMVP2ClickSubmit,
    analyticsCardSelectMinimumPaymentMVP2ClickLearnMore,
    analyticsCardSelectMinimumPaymentMVP2ViewDDModal,
    analyticsCardSelectMinimumPaymentMVP2CloseDDModal,
} from '@perpay-web/fintech/actions/analytics/cardOnboardingMVP2';
import {
    createDeduction,
    clearDeductionError,
} from '@perpay-web/fintech/actions/entities/deductions';
import { payrollPaymentSetupStart } from '@perpay-web/fintech/actions/payrollPaymentSetup';
import { replaceAmountToCharge } from '@perpay-web/fintech/actions/ui/cardOnboardingMVP2';
import CardApplicationSelectMinimumPayment from '@perpay-web/fintech/components/composite/CardApplicationSelectMinimumPayment/CardApplicationSelectMinimumPayment';
import { PINWHEEL_STEP } from '@perpay-web/fintech/components/screens/CardApplication/CardApplicationSteps';
import { useCardApplicationContext } from '@perpay-web/fintech/components/screens/CardApplication/useCardApplicationContext';
import { IS_PAYCHEX_LAUNCHED } from '@perpay-web/fintech/constants/flags';
import {
    getMinimumPayment,
    getIsPinwheelEligible,
    getIsPayrollPaymentSetupUser,
} from '@perpay-web/fintech/dataModules/composed/cardPaymentSummary';
import { useAppSelector } from '@perpay-web/fintech/hooks';
import { createPayrollDeductionSetAmount } from '@perpay-web/fintech/hooks/dataModule/useCreatePayrollDeductionContext';
import {
    getFetchingPinwheelToken,
    getPinwheelErrors,
} from '@perpay-web/fintech/selectors/ui/cardOnboardingMVP2';

const CardApplicationSelectMinimumPaymentContainer = ({
    setManualPaymentSetupStep,
}) => {
    const dispatch = useDispatch();

    const isSubmitting = useSelector(getFetchingPinwheelToken);
    const errors = useSelector(getPinwheelErrors);
    const totalMinimumPayment = useSelector(getMinimumPayment);
    const isPinwheelEligible = useSelector(getIsPinwheelEligible);
    const { setStep } = useCardApplicationContext();
    const isPayrollPaymentSetupUser = useAppSelector(
        getIsPayrollPaymentSetupUser,
    );

    // the increased deposit is 1.15 times the minimum payment rounded up to the nearest 5
    const increasedDeposit =
        Math.ceil((totalMinimumPayment * 1.15) / 500) * 500;

    const handleClickSetUpPayment = (amountToDeduct) => {
        dispatch(
            analyticsCardSelectMinimumPaymentMVP2ClickSubmit(amountToDeduct),
        );

        if (IS_PAYCHEX_LAUNCHED && isPayrollPaymentSetupUser) {
            dispatch(replaceAmountToCharge(amountToDeduct));
            dispatch(createPayrollDeductionSetAmount(amountToDeduct));
            dispatch(payrollPaymentSetupStart());
            return;
        }

        if (!isPinwheelEligible) {
            dispatch(replaceAmountToCharge(amountToDeduct));
            setManualPaymentSetupStep();
        } else {
            dispatch(createDeduction({ amount: amountToDeduct }));
            dispatch(replaceAmountToCharge(amountToDeduct));
            setStep(PINWHEEL_STEP);
        }
    };

    return (
        <CardApplicationSelectMinimumPayment
            isSubmitting={isSubmitting}
            errors={errors}
            totalMinimumPayment={totalMinimumPayment}
            increasedDeposit={increasedDeposit}
            isPinwheelEligible={isPinwheelEligible}
            onClickLearnMore={() => {
                dispatch(analyticsCardSelectMinimumPaymentMVP2ClickLearnMore());
            }}
            onDirectDepositModalViewed={() => {
                dispatch(analyticsCardSelectMinimumPaymentMVP2ViewDDModal());
            }}
            onDirectDepositModalClosed={() => {
                dispatch(analyticsCardSelectMinimumPaymentMVP2CloseDDModal());
            }}
            onUnmount={() => {
                dispatch(clearDeductionError());
            }}
            onClickSetUpPayment={handleClickSetUpPayment}
        />
    );
};

export default CardApplicationSelectMinimumPaymentContainer;
